import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export const routes = [
  //加盟页
  {
    path: "/join/join",
    name: "joinIn",
    meta: { title: "聚亲族谱加盟" },
    component: () =>
      import( /* webpackChunkName: 'about' */ "@/views/join/join")
    // redirect: "/pedigree/form/login"
  },
  // 下载页
  {
    path: "/download",
    name: "donwload",
    meta: { title: "下载页" },
    component: () =>
      import( /* webpackChunkName: 'about' */ "@/views/download/index.vue")
  },
  // 富文本
  {
    path: "/rich",
    name: "rich",
    meta: { title: "" },
    component: () =>
      import( /* webpackChunkName: 'about' */ "@/views/rich/index.vue")
  },
  // 群主页
  {
    path: "/team/detail",
    name: "team-detail",
    meta: { title: "群主页" },
    component: () =>
      import( /* webpackChunkName: 'about' */ "@/views/team/detail/index.vue")
  },
  // 群公告
  {
    path: "/team/announcement",
    name: "team-announcement",
    meta: { title: "群公告" },
    component: () =>
      import(
        /* webpackChunkName: 'about' */
        "@/views/team/announcement/index.vue"
      )
  },
  // 群二维码
  {
    path: "/team/code",
    name: "team-announcement",
    meta: { title: "群组二维码" },
    component: () =>
      import( /* webpackChunkName: 'about' */ "@/views/team/code/index.vue")
  },
  // 群族谱二维码
  {
    path: "/team/pedigree",
    name: "team-announcement",
    meta: { title: "族谱二维码" },
    component: () =>
      import( /* webpackChunkName: 'about' */ "@/views/team/pedigree/index.vue")
  },
  // 用户二维码
  {
    path: "/user/code",
    name: "user-announcement",
    meta: { title: "用户二维码" },
    component: () =>
      import( /* webpackChunkName: 'about' */ "@/views/user/code/index.vue")
  },
  // 活动管理 - 活动详情
  {
    path: "/activity/detail",
    name: "activity-detail",
    meta: { title: "活动详情" },
    component: () =>
      import(
        /* webpackChunkName: 'about' */
        "@/views/activity/detail/index.vue"
      )
  },
  {
    path: "/activity/voucher",
    name: "activity-voucher",
    meta: { title: "活动凭证" },
    component: () =>
      import(
        /* webpackChunkName: 'about' */
        "@/views/activity/voucher/index.vue"
      )
  },
  {
    path: "/pedigree",
    name: "pedigree",
    meta: { title: "族谱" },
    component: () =>
      import( /* webpackChunkName: 'about' */ "@/views/pedigree/index.vue")
  },
  {
    path: "/pedigree/form/new/new_form",
    name: "pedigreeNewNewForm",
    meta: { title: "填写个人资料" },
    redirect: "/pedigree/form/login"
  },
  {
    path: "/pedigree/form/new/mate_form",
    name: "pedigreeNewMateForm",
    meta: { title: "填写配偶资料" },
    // component: () => import(/* webpackChunkName: 'about' */ '@/views/pedigree_form_new/form/mate_form.vue')
    redirect: "/pedigree/form/login"
  },
  {
    path: "/pedigree/form/new/form",
    name: "pedigreeNewForm",
    meta: { title: "填写兄弟姐妹资料" },
    // component: () => import(/* webpackChunkName: 'about' */ '@/views/pedigree_form_new/form/form.vue')
    redirect: "/pedigree/form/login"
  },
  {
    path: "/pedigree/form/new/childForm",
    name: "pedigreeNewChildForm",
    meta: { title: "填写儿女资料" },
    // component: () => import(/* webpackChunkName: 'about' */ '@/views/pedigree_form_new/form/childForm.vue')
    redirect: "/pedigree/form/login"
  },
  {
    path: "/pedigree/form/new/fatherForm",
    name: "pedigreeNewFatherForm",
    meta: { title: "填写父亲资料" },
    // component: () => import(/* webpackChunkName: 'about' */ '@/views/pedigree_form_new/form/fatherForm.vue')
    redirect: "/pedigree/form/login"
  },
  {
    path: "/pedigree/form/new/grandfatherForm",
    name: "pedigreeNewGrandfatherForm",
    meta: { title: "填写祖父资料" },
    // component: () => import(/* webpackChunkName: 'about' */ '@/views/pedigree_form_new/form/grandfatherForm.vue')
    redirect: "/pedigree/form/login"
  },
  {
    path: "/pedigree/form/new/grandchildForm",
    name: "pedigreeNewGrandChildForm",
    meta: { title: "填写孙辈资料" },
    // component: () => import(/* webpackChunkName: 'about' */ '@/views/pedigree_form_new/form/grandchildForm.vue')
    redirect: "/pedigree/form/login"
  },
  {
    path: "/pedigree/form/tree",
    name: "pedigreeFromTree",
    meta: { title: "树谱" },
    // component: () => import(/* webpackChunkName: 'about' */ '@/views/pedigree_form_new/tree.vue')
    redirect: "/pedigree/form/login"
  },
  {
    path: "/pedigree/form",
    name: "pedigreeFrom",
    meta: { title: "添加代表人/户主" },
    // component: () => import(/* webpackChunkName: 'about' */ '@/views/pedigree_form_new/index.vue')
    redirect: "/pedigree/form/login"
  },
  {
    path: "/pedigree/form/login",
    name: "pedigreenewLogin",
    meta: { title: "登录" },
    component: () =>
      import(
        /* webpackChunkName: 'about' */
        "@/views/pedigree_form_new/login.vue"
      )
  },
  {
    path: "/pedigree/form/userule",
    name: "pedigreenewrule",
    meta: { title: "填写说明" },
    // component: () => import(/* webpackChunkName: 'about' */ '@/views/pedigree_form_new/useRule.vue')
    redirect: "/pedigree/form/login"
  },
  {
    path: "/pedigree/form/new/monChildForm",
    name: "monChildForm",
    meta: { title: "填写儿女资料" },
    // component: () => import(/* webpackChunkName: 'about' */ '@/views/pedigree_form_new/form/monChildForm.vue')
    redirect: "/pedigree/form/login"
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { y: 0 };
  }
});

export default router;